import React from 'react'
import { Box, Flex, Heading, HStack, Text } from '@chakra-ui/react'
import ContainerContent from './ContainerContent'
import PropTypes from 'prop-types'
import ProfileMenu from '../ProfileMenu'
import LinkedLogo from '../LinkedLogo'
import rootStore from '../../../store/RootStore'
import { observer } from 'mobx-react'

const Header = observer(({ title, reportTitle: mainTitle, ...rest }) => {
  const {
    planStore: { currentPlan },
  } = rootStore
  return (
    <Flex
      w="100vw"
      h="180px"
      bg={'brand.blueGradient'}
      color={'white'}
      {...rest}>
      <HStack w={'100%'}>
        <LinkedLogo />
        <ContainerContent>
          <Text
            mb="16px"
            position={['fixed', 'fixed', 'initial', 'initial', 'initial']}
            top={['80px', '80px', '80px', '80px', 'initial']}
            left={['20px', '20px', '20px', '20px', 'initial']}
            paddingRight={['20px', '20px', '20px', '20px', 'initial']}
            fontSize={['sm', 'sm', 'sm', 'sm', 'initial']}>
            {mainTitle}
          </Text>
          <Heading
            as="h1"
            color="white"
            position={['fixed', 'fixed', 'initial', 'initial', 'initial']}
            top={['130px', '130px', '130px', '130px', 'initial']}
            left={['20px', '20px', '20px', '20px', 'initial']}
            paddingRight={['20px', '20px', '20px', '20px', 'initial']}
            fontSize={['xl', 'xl', 'xl', 'xl', '3xl']}>
            {title}
          </Heading>
        </ContainerContent>
        <Box
          flex={1}
          marginTop={[
            '-100px !important',
            '-100px !important',
            '0px !important',
            '0px !important',
            '0px !important',
          ]}
          paddingRight={['10px', '10px', '10px', '10px', 'initial']}>
          <ProfileMenu
            client={currentPlan?.planName ?? '- No Plan Selected -'}
          />
        </Box>
      </HStack>
    </Flex>
  )
})

Header.propTypes = {
  rest: PropTypes.any,
  title: PropTypes.string,
  reportTitle: PropTypes.string || PropTypes.element,
  navigate: PropTypes.any,
}

export default Header
